import { toast as sonnerToast } from 'sonner';

/**
 * Re-export of Sonner toast with consistent defaults.
 * Use these helpers for a unified toast API across the app.
 */
export const toast = {
  success: (message: string) => sonnerToast.success(message),
  error: (message: string) => sonnerToast.error(message),
  info: (message: string) => sonnerToast.info(message),
  loading: (message: string) => sonnerToast.loading(message),
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
  promise: sonnerToast.promise,
};
